import React, { useContext } from 'react'
import {Form, Input} from "antd";
import {RecipeUpdateContext} from "../../../../../context/RecipeUpdateContext";

const { TextArea } = Input


const HeaderDescription = () => {
    const {byId} = useContext(RecipeUpdateContext)
    const [recipeById, setRecipeById] = byId

    const handleDescriptionChange = (value) => {
        let mockResponse = Object.assign({}, recipeById)
        mockResponse.recipe.description = value
        setRecipeById(mockResponse)
    }

    return(
        <React.Fragment>
            <Form.Item
                className={'font-bold'}
                name={'recipeDescription'}
                label={'Reçete Açıklaması'}
                initialValue={recipeById.recipe.description}
            >
                <TextArea onChange={(event => handleDescriptionChange(event.target.value))} />
            </Form.Item>
        </React.Fragment>
    )
}
export default HeaderDescription